import EngineModule from '../EngineModule';
import {NS as HomeNS} from '../components/Home/Home';

export default () => new EngineModule.UIEngineModule({
	type: 'ui',
	useFullWidth: true,
	id: 'home',
	dependencies: [],
	modulesBefore: [],
	modulesAfter: [
		'product-editor',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor',
		'viewer-planner-floor-editor',
		'viewer-planner-walls-editor',
		'viewer-planner-furniture-editor'
	],
	allowedCustomers: null,
	usableCondition: null,
	displayCondition: null,
	generateComponentConfiguration(): HomeNS.Configuration {
		return {};
	},
	async initialize() {
	}
});
